import * as types from './reportActionTypes';

export default (state = [], action) => {
    switch (action.type) {
        case types.SELECT_FILTER_REPORTS:
            {
                const exists = state.filter(f => f === action.value).length > 0;
                if (exists) {
                    return state.filter(f => f !== action.value);
                }

                return [...state, action.value];
            }
        default:
            return state;

    }
};


// WEBPACK FOOTER //
// ./src/reports/reportsFilterReducer.js